import React from 'react';
import { useDispatch } from 'react-redux';
import type { WikiPage } from '../../api/wiki/interface';
import { useSelector } from '../store';
import { actions as wikiActions, pageKey, type PageStatus } from './logic';

interface WikiPageHookState {
  page: WikiPage | undefined;
  hasData: boolean;
  status: PageStatus | undefined;
}

interface WikiPageHookHandler {
  fetchPage: () => void;
}

export default function useWikiPageHook(
  dossierId: string,
  path: string
): [WikiPageHookState, WikiPageHookHandler] {
  const dispatch = useDispatch();
  const key = pageKey(dossierId, path);
  const page = useSelector((s) => s.wiki.pages[key]);
  const status = useSelector((s) => s.wiki.status[key]);
  const hasData = page !== undefined;

  const handler = React.useMemo<WikiPageHookHandler>(
    () => ({
      fetchPage: () => {
        dispatch(wikiActions.fetchPage({ dossierId, path }));
      },
    }),
    [dispatch, dossierId, path]
  );

  return [{ page, hasData, status }, handler];
}
